import dynamic from "next/dynamic";
import Link from "next/link";
import { Nav } from "react-bootstrap";

const HeaderBlog = dynamic(() => import('./HeaderBlog'))
// const HeaderBottom = dynamic(() => import('./HeaderBottom'))
const SubMenu = dynamic(() => import('./SubMenu'))

const DesktopMenu = ({
	menuDetails,
	activeMenuTab,
	menuItemClass,
	handleMouseOver,
	handleMouseOut,
	handleMenuItemClick,
	handleMainMenuClick,
	getTitles,
	handleMenuClick,
	getActiveClass,
	showModal,
	toggleIsMore,
	isMore,
	getActiveData
}) => {
	const getServiceHref = (ele) => {
		return ele.submenu.find((el) => el.title == "All Services").href
	}
	return (
		<>
			<Nav className="ms-auto desktop-menu">
				<ul className="menu-items">
					{menuDetails.map((ele, index) => {
						return ele?.submenu.length > 0 ? (
							<li
								key={index}
								className="navItem"
								onMouseEnter={() => {
									handleMouseOver(index);
								}}
								onMouseLeave={() => {
									handleMouseOut(index);
								}}
							>
								<Link
									href={ele.href ? ele.href : "#"}
									onClick={(e) => {
										handleMenuItemClick(index, e);
										if (ele.href) {
											handleMainMenuClick(
												index,
												ele.href
											);
										} else {
											e.preventDefault();
										}
									}}
									className={`nav-link ${activeMenuTab.title === ele.title
										? "active"
										: ""
										}`}
									aria-label={ele.title}
									prefetch={true}
								>
									{ele.title}
								</Link>

								{/* submenu d-block */}
								<div
									className={`${menuItemClass} d-none`}
									id={`submenu-${index}`}
								>
									<div className="submenu-inner">
										<div className="container">
											<div className="section-main-submenu h-100">
												<div className="row">
													<div className="col-lg-4 ">
														<div className="submenu-new-design">
															<HeaderBlog
																data={ele}
																blogDetails={
																	ele?.Ref_Blog
																}
															/>
														</div>
													</div>
													<div className="col-lg-8 ">
														<div className="right-menu-root">
															<div className="row">
																<div className="col-lg-12">
																	<div className="menu-heading menu-heading-new">
																		<p>
																			{ele.title}
																		</p>
																		{
																			ele.title == 'Services' &&
																			<Link href={getServiceHref(ele) || '#'}>
																				All Services
																			</Link>
																		}
																		{
																			isMore &&
																			<Link href={"/"} onClick={(e) => { e.preventDefault(), e.stopPropagation(), toggleIsMore() }} className="seemore-sublink">See Less</Link>
																		}
																	</div>
																</div>
															</div>
															<div className="row row-height">
																<div className="col-lg-12">
																	<SubMenu
																		menuIndex={index}
																		menu={ele}
																		activeMenuTab={activeMenuTab}
																		handleMenuClick={
																			handleMenuClick
																		}
																		getActiveClass={
																			getActiveClass
																		}
																		getActiveData={getActiveData}
																		toggleIsMore={toggleIsMore}
																		isMore={isMore}
																	/>
																</div>
															</div>

														</div>

													</div>

												</div>
											</div>
										</div>
									</div>
								</div>
							</li>
						) : (
							<li key={index} className="navItem">
								<Link
									href={ele.href ? ele.href : "#"}
									onClick={(e) => {
										if (ele.href) {
											handleMainMenuClick(
												index,
												ele.href
											);
										} else {
											e.preventDefault();
										}
									}}
									className={`nav-link ${activeMenuTab.title === ele.title
										? "active"
										: ""
										}`}
									aria-label={ele.title}
									prefetch={true}
								>
									{ele.title}
								</Link>
							</li>
						);
					})}
				</ul>
			</Nav>
		</>
	);
};

export default DesktopMenu;

